import { HttpClient } from '../utils/httpClient';

const PATH = {
    readAll: '/root/content-manager',
    create: '/root/content-manager',
    delete: '/root/content-manager',
    update: '/root/content-manager',
};

const ReadAll = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(PATH.readAll, { params }).then(callback).catch(error).finally(next);
};

const Create = (payload, start, callback, error, next) => {
    start();
    return HttpClient.post(PATH.create, payload).then(callback).catch(error).finally(next);
};

const Update = (id, payload, start, callback, error, next) => {
    start();
    return HttpClient.patch(`${PATH.update}/${id}`, payload).then(callback).catch(error).finally(next);
};

const Delete = (data, start, callback, error, next) => {
    start();
    return HttpClient.delete(`${PATH.delete}/${data.id}`, { params: data }).then(callback).catch(error).finally(next);
};
export const RootContentManageService = {
    ReadAll,
    Create,
    Update,
    Delete,
};
